/* eslint-disable react/jsx-no-literals, react/no-danger */

// React Libraries.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import getHTMLElement from '../lib/setHtmlHelper';

/**
 * VideoModalPlayer Component helps to add the play now icon and open pop up modal to play video.
 */
class VideoModalPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalId: new Date().getTime(),
      modalIsOpen: false,
    };

    this.videoType = '';
    this.closeModal = this.closeModal.bind(this);
  }

  // To hide the body when modal is open (ADA requirement)
  componentWillMount() {
    Modal.setAppElement('body');
  }

  // Triggers, When its mounted first time.
  componentDidMount() {
    // Removing the Thumbnail, when Video exist.
    if (this.props.id && this.videoType) {
      const desc = document.querySelector(`#${this.props.id} p.tile_description`);
      if (desc && desc.parentNode) {
        //desc.remove();
        desc.parentNode.removeChild(desc);
      }
    }
  }

  // Trigger, when there is state update.
  componentDidUpdate(prevProps, prevState) {
    const { modalId, modalIsOpen } = this.state;

    // When Modal opens.
    if (modalIsOpen === true && prevState.modalIsOpen === false) {
      const $videoModal = document.querySelector(`#video-modal-${modalId}`);
      if (this.videoType === 'dam') {
        const $video = ($videoModal && $videoModal.querySelector) ? $videoModal.querySelector('video') : '';
        if ($video && $video.play) {
          $video.play();
        }
      } else if ( this.videoType === 'youtube') {
        const $video = ($videoModal && $videoModal.querySelector)
                          ? $videoModal.querySelector('iframe[src*=youtu]') : '';
        if ($video && $video.src) {
          const q = ($video.src.indexOf('?') > -1) ? '&' : '?';
          $video.src += `${q}autoplay=1`;
        }
      }
    }
  }

  // Open Video Player Modal.
  onPlayCick(event) {
    event.preventDefault();
    this.setState({
      modalIsOpen: true
    });
  }

  // Modal Custom Styles.
  getCustomStyle() {
    return {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        padding: '0',
        transform: 'translate(-50%, -50%)',
        borderRadius: '1rem',
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, .65)',
        zIndex: '1000'
      }
    };
  }

  // Detect for Video Exist and Add Play Now Icon.
  getVideoModalPlayer() {
    const videoContent = this.props.source;
    const slugId = this.props.slugId;
    if(videoContent && videoContent.includes('video')) {
      this.videoType = 'dam';
    }else if(videoContent && videoContent.includes('iframe')) {
      this.videoType = 'youtube';
    }
    if (videoContent) {
      const innerHTML = getHTMLElement(videoContent, {useHTML: true });
      return (
        <div className="video-modal-player">
          <button  className={`brcHomeVideoClick|${slugId}| circle`} aria-label ="play video"
            onClick={(e) => this.onPlayCick(e)} >
            <div className={`brcHomeVideoClick|${slugId}| triangle-right`} />
          </button>
          <Modal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} style={this.getCustomStyle()}>
            <div id={`video-modal-${this.state.modalId}`}>
              <div className="video-modal-header">
                <button className="close" aria-label ="close video"onClick={() => this.closeModal()}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="video-modal-body">{innerHTML}</div>
            </div>
          </Modal>
        </div>
      );
    }

    return null;
  }

  // Close the Video Player Modal.
  closeModal() {
    this.setState({
      modalIsOpen: false
    });
  }

  // Render the Play Now Icon to Open Video Player Modal.
  render() {
    return this.getVideoModalPlayer();
  }
}

// VideoModalPlayer Props Types.
VideoModalPlayer.propTypes = {
  id: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  slugId: PropTypes.string.isRequired
};

// VideoModalPlayer Props default values.
VideoModalPlayer.defaultProps = {
  id: '',
  source: '',
  slugId: ''
};

export default VideoModalPlayer;
